<template>
  <div class="loading-popup-container" :style="{ display: show ? 'flex' : 'none' }">
    <envizion-loader :size="48" />
    <div class="loading-progress-track">
      <div class="loading-progress-fill"></div>
    </div>
    <div class="loading-label">{{ text || 'Preparing your workspace' }}</div>
  </div>
</template>

<script>
  export default {
    name: 'LoadingPopup',
    props: ['show', 'text'],
  };
</script>

<style scoped>
  .loading-popup-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    width: 100%;
    height: 100%;
  }

  .loading-progress-track {
    width: 200px;
    height: 2px;
    background: #e2e6ea;
    border-radius: 1px;
    overflow: hidden;
  }

  .loading-progress-fill {
    width: 40%;
    height: 100%;
    background: #03624c;
    border-radius: 1px;
    animation: loading-slide 1.6s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }

  @keyframes loading-slide {
    0% { transform: translateX(-100%); width: 40%; }
    50% { width: 60%; }
    100% { transform: translateX(350%); width: 40%; }
  }

  .loading-label {
    font-size: 12px;
    color: #8c959f;
    letter-spacing: 0.5px;
    margin-top: -16px;
  }
</style>
